
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PreviewIntroContent from "./PreviewIntroContent.vue";
import {
  formatJieLongLaunchedLabel,
  isTerminalJieLongStatus,
  JIELONG_STATUS as JIELONG_STATUS_MAP,
  JielongIntroCardDetail,
  JielongPreviewActivity,
  parseJielongTime,
  pickJielongEndCountdownTime,
} from "@/api/jielong";
import { downloadUrl } from "@/utils/util";

const COLLAPSE_MAX_HEIGHT = 80;
const DEFAULT_AVATAR = require("@/assets/images/photo-bg.png");

@Component({ components: { PreviewIntroContent } })
export default class PreviewIntroSection extends Vue {
  @Prop({ required: true }) activity!: JielongPreviewActivity;
  @Prop({ type: Array, default: () => [] }) details!: JielongIntroCardDetail[];
  @Prop({ type: Boolean, default: false }) isDetailMode!: boolean;

  expanded = false;
  overflowContent = false;
  sftpUrl = "";

  JIELONG_STATUS = JIELONG_STATUS_MAP;

  get statusLabel (): string {
    if (!this.isDetailMode) return "接龙尚未发起";
    return formatJieLongLaunchedLabel(this.activity.createTime || this.activity.startTime);
  }

  get viewAvatars (): string[] {
    const list = this.activity.browseList || [];
    return list.slice(0, 3).map((item) => item.avatarUrl);
  }

  get statusTimeClass (): string {
    if (this.activity.status === JIELONG_STATUS_MAP.ENDED) return "pis-status-time--ended";
    if (this.activity.status === JIELONG_STATUS_MAP.CANCELLED) return "pis-status-time--cancelled";
    if (this.activity.status === JIELONG_STATUS_MAP.NOT_STARTED) return "pis-status-time--notStarted";
    return "pis-status-time--ongoing";
  }

  get countdownPrefix (): string {
    return this.activity.status === JIELONG_STATUS_MAP.NOT_STARTED ? "距离开始" : "距离结束";
  }

  get remainMs (): number {
    const target =
      this.activity.status === JIELONG_STATUS_MAP.NOT_STARTED
        ? this.activity.startTime
        : pickJielongEndCountdownTime(
          this.activity.status,
          this.activity.endTime,
          this.activity.extendTime
        );
    const diff = parseJielongTime(target) - Date.now();
    return diff > 0 ? diff : 0;
  }

  get countdownKey (): string {
    return `${this.activity.status}|${this.activity.startTime}|${this.activity.endTime}|${this.activity.extendTime || ""}`;
  }

  get showToggle (): boolean {
    return this.overflowContent && !this.expanded;
  }

  get showFade (): boolean {
    return this.overflowContent && !this.expanded;
  }

  padZero (num: number): string {
    return num < 10 ? `0${num}` : String(num);
  }

  mounted (): void {
    this.sftpUrl = this.$store.state.user.sftpUrl
    this.$nextTick(() => {
      this.measureOverflow();
      this.$emit("layout-change");
    });
  }

  @Watch("details", { deep: true })
  onDetailsChange (): void {
    this.$nextTick(() => this.measureOverflow());
  }

  measureOverflow (): void {
    const content = this.$refs.introContent as PreviewIntroContent | undefined;
    const height = content ? content.getContentHeight() : 0;
    this.overflowContent = height > COLLAPSE_MAX_HEIGHT;
    if (!this.overflowContent) {
      this.expanded = false;
    }
  }

  toggleExpand (): void {
    this.expanded = !this.expanded;
    this.$emit("expand-change", this.expanded);
    this.$nextTick(() => this.$emit("layout-change"));
  }
}
